import { WEB_ICO } from './icons';
import { WEB_NAV_MAIN, type NavKey } from './nav';

/// Trang con (thư viện, cài đặt…) vẫn sáng tab cha của nó — khớp cách mobile lồng stack trong tab.
const TAB_OF: Partial<Record<NavKey, NavKey>> = {
  kanaLib: 'ontap',
  decks: 'ontap',
  deckItems: 'ontap',
  srsSettings: 'ontap',
  account: 'hoso',
  editProfile: 'hoso',
  about: 'hoso',
  privacy: 'hoso',
  terms: 'hoso',
  placeholder: 'hoso',
};

const SHORT_LABEL: Partial<Record<NavKey, string>> = { ai: 'AI' };

/// "Cộng đồng" đậm 11.5px rộng ~62px — nhỉnh hơn 1/6 của màn 360px nên cho tab này rộng hơn chút,
/// cùng cách TAB_FLEX trong AppTabBar của mobile.
const TAB_FLEX: Partial<Record<NavKey, number>> = { congdong: 1.25 };

/**
 * Thanh tab dưới cho web trên điện thoại (< 640px) — thay sidebar. Cùng ngôn ngữ với
 * AppTabBar của mobile: vạch màu mép trên, pill nền sau icon, nhãn đậm ở tab đang chọn.
 */
export function WebBottomNav({
  active,
  onNav,
  aiEnabled = true,
  socialEnabled = true,
  due = 0,
  chatUnread = 0,
}: {
  active: NavKey;
  onNav: (key: NavKey) => void;
  aiEnabled?: boolean;
  socialEnabled?: boolean;
  due?: number;
  chatUnread?: number;
}) {
  const current = TAB_OF[active] ?? active;
  const items = WEB_NAV_MAIN.filter((i) => (i.key !== 'ai' || aiEnabled) && ((i.key !== 'congdong' && i.key !== 'chat') || socialEnabled));
  // 6 tab trên màn 360px: mỗi tab còn ~58px, pill 56 sát mép nhau nên thu lại.
  const pillWidth = items.length > 4 ? 48 : 56;
  return (
    <nav
      aria-label="Điều hướng chính"
      style={{
        display: 'flex',
        flexShrink: 0,
        background: 'var(--surface-page)',
        borderTop: '1px solid var(--border-default)',
        boxShadow: '0 -4px 16px rgba(1,31,75,0.06)',
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
        fontFamily: 'var(--font-vi)',
      }}
    >
      {items.map((item) => {
        const on = current === item.key;
        const badge = item.key === 'ontap' && due > 0 ? due : item.key === 'chat' && chatUnread > 0 ? chatUnread : null;
        return (
          <button
            key={item.key}
            onClick={() => onNav(item.key)}
            aria-current={on ? 'page' : undefined}
            style={{
              position: 'relative',
              flex: TAB_FLEX[item.key] ?? 1,
              minWidth: 0,
              minHeight: 58,
              padding: '8px 0 6px',
              border: 'none',
              background: 'none',
              cursor: 'pointer',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 3,
              fontFamily: 'inherit',
              WebkitTapHighlightColor: 'transparent',
            }}
          >
            <span style={{ position: 'absolute', top: 0, width: 32, height: 3, borderRadius: '0 0 3px 3px', background: on ? 'var(--cta-default)' : 'transparent' }} />
            <span
              style={{
                position: 'relative',
                width: pillWidth,
                height: 30,
                borderRadius: 999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: on ? 'rgba(0,91,150,0.14)' : 'transparent',
                transition: 'background .15s ease',
              }}
            >
              {WEB_ICO[item.ico](on ? 'var(--cta-default)' : 'var(--navy-300)', 22)}
              {badge != null && (
                <span
                  style={{
                    position: 'absolute',
                    top: -2,
                    right: pillWidth / 2 - 22,
                    minWidth: 18,
                    height: 18,
                    padding: '0 5px',
                    borderRadius: 999,
                    background: 'var(--cta-default)',
                    color: '#fff',
                    fontSize: 10.5,
                    fontWeight: 700,
                    lineHeight: '18px',
                    textAlign: 'center',
                  }}
                >
                  {badge > 99 ? '99+' : badge}
                </span>
              )}
            </span>
            <span style={{ fontSize: 11.5, lineHeight: '14px', fontWeight: on ? 700 : 500, color: on ? 'var(--nav-active)' : 'var(--text-secondary)', whiteSpace: 'nowrap' }}>
              {SHORT_LABEL[item.key] ?? item.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
